// extracted by mini-css-extract-plugin
export default {"workInProgress":"work-in-progress_workInProgress__AoNTV","status":"work-in-progress_status__ja5IL"};